<template>
  <div class="wrap">
    <!-- 背景图 -->
    <img class="bc_img" :src="url1" alt="" />
    <div class="system">商户信息管理系统</div>

    <div class="content">
      <div class="person">用户登录</div>

      <div class="person_name">
        <img class="user_bc" :src="url_user" alt="" />
        <input
          class="user"
          value=""
          placeholder="用户名"
          v-model="user"
          type="text"
        />
      </div>

      <div class="pwDiv">
        <img class="user_pw" :src="url_pw" alt="" />
        <input class="pw" placeholder="密码" v-model="pw" :type="telphone" />
        <div @click.stop="smallEyes" class="off">
          <img :src="off" class="on" alt="" v-show="eyetel" />
          <img :src="on" class="on" alt="" v-show="!eyetel" />
        </div>
      </div>

      <!-- 登录按钮 -->
      <button class="login_btn" @click="newsjump">登录</button>
    </div>
    <!-- —————————————————————————————————— -->
    <div class="buttom">
      Copyright©2012紫旭智慧科技集团 版权所有|京ICP备13012014号
    </div>
  </div>
</template>

<script>
import { createCookie, getOrDestroy } from "../utils";
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      pw: "",
      user: "",
      telphone: "password", // 默认数字加密
      eyetel: true, // 默认显示闭眼的图片
      url1: require("./img/背景.png"),
      url_user: require("./img/用户.png"),
      url_pw: require("./img/密码.png"),
      off: require("./img/view_off.png"),
      on: require("./img/view.png"),
    };
  },
  methods: {
    // 切换图片显示数字
    smallEyes() {
      this.eyetel = !this.eyetel;
      this.telphone = this.telphone == "password" ? "text" : "password";
    },
    // 登录——————————————
    newsjump() {
    
      const url = "/api/admin/userInfo/login";
      axios
        .post(url, {
          username: this.user,
          password: this.pw,
        })
        .then((res) => {
          
          if (res.data.code === 20000) {
            createCookie("loginStatus", true, "min", 20);
            this.$router.push({
              name: "home",
            });
          } else {
            throw res.data || "登陆失败!";
          }
        })
        .catch((err) => {
          getOrDestroy("loginStatus", 0);
          this.$alert(err.message || "服务器错误", "提 示", {
            type: "warning",
          });
          console.warn(err);
        });
    },
  },
};
</script>

<style scoped>
body {
  background-image: url("./img//背景.png");
  background-size: cover;
  background-position: center;
  font: 14px/1.5 tahoma, arial, "Hiragino Sans GB", "\5b8b\4f53", sans-serif;
  color: #4d4d4d;
  -webkit-font-smoothing: antialiased;
 
}
.wrap {
  width: 100%;
  height: 940px;
  background-color: #090e1b;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  position: relative;

}
.bc_img {
  width:1300px;
 
}

.system {
  height: 0.09rem;
  font-family: MicrosoftYaHei;
  font-size: 0.09rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  position: fixed;
  top: 0.45rem;
}
.buttom {
  height: 0.04rem;
  font-family: MicrosoftYaHei;
  font-size: 0.03rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  position: fixed;
  top: 1.91rem;
}
.content {
  width: 0.98rem;
  height: 0.91rem;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 0.02rem;

  position: fixed;
  top: 0.64rem;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-around;
}
.content > div {
  width: 100%;
}
.person {
  font-family: MicrosoftYaHei-Bold;
  font-size: 0.05rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;

  position: absolute;
  left: 0.14rem;
  top: 0.09rem;
}
.person_name {
  height: 0.1rem;
  position: absolute;
  top: 0.27rem;
}

.user_bc,
.user_pw {
  width: 0.04rem;
  color: #fff;
  height: 0.04rem;
  margin-left: 0.14rem;
}

.user {
  width: 0.65rem;
  border-bottom: 0.001rem solid #fff;
  font-size: 0.04rem;
  font-family: MicrosoftYaHei;
  background: rgba(0, 0, 0, 0);
  color: #fff;
}
input::-webkit-input-placeholder {
  /* 修改placeholder字体颜色 */
  color: #cccccc;
  background: rgba(0, 0, 0, 0);
}

.pw {
  width: 0.65rem;
  border-bottom: 0.001rem solid #fff;
  font-size: 0.04rem;
  font-family: MicrosoftYaHei;
  background: rgba(0, 0, 0, 0);
  color: #fff;
}

.pwDiv {
  position: absolute;
  top: 0.41rem;
}
.off {
  width: 0.045rem;
  position: absolute;
  right: 0.14rem;
  top: -0.005rem;
}
.on {
  width: 100%;
}

:focus {
  outline: 0;
}
.login_btn {
  width: 0.71rem;
  height: 0.11rem;
  background-image: linear-gradient(0deg, #1f6acb 0%, #2876da 100%);
  border-radius: 0.01rem;
  border: none;
  font-family: MicrosoftYaHei;
  font-size: 0.05rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  color: #ffffff;
  position: absolute;
  left: 0.13rem;
  top: 0.67rem;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue